import { Injectable } from '@angular/core';

import 'rxjs/add/operator/map';

import { Constants } from './app.constants';

import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class UserService {

  private actionUrl: string;
  private apiKey: string;
  private apiPassword: string;

  constructor(private http: HttpClient, private _constants: Constants) {
	this.actionUrl = _constants.ServerWithApiUrl;
    this.apiKey = _constants.APIKey;
    this.apiPassword = _constants.APIPassword;
  }
  
  // validate login data
  login(data){
    const headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set(this.apiKey, this.apiPassword);
	return this.http.post(this.actionUrl +'auth/login',data, { headers: headers })
	.map((response:Response) => response)
  }
 // Get auth user details	
  getAuthUser(data){
    let params = new URLSearchParams();
    let url = this.actionUrl + 'auth/user';
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${data.data.user_token}`);
   
    return this.http.get(url, {params: {token: data.data.user_token}, headers: headers})
	.map((response:Response) => response)
  }

  getAuthUserByToken(token){
    let params = new URLSearchParams();
    let url = this.actionUrl + 'auth/user';
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${token}`);
   
    return this.http.get(url, {params: {token: token}, headers: headers})
	.map((response:Response) => response)
  }
 // get role Lists
  getRoleLists(data){
    let params = new URLSearchParams();
    let url = this.actionUrl + 'role/lists';
    const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
    return this.http.get(url, {headers})
      .map((response:Response) => response)
  }
   // get role Lists
   
 VerifyPhone_Number(data){
    let url = this.actionUrl + 'auth/user/verifyphone';
    const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
    const params = {
        otp_method: data.otp_method,
        confirm_phone_number: data.confirm_phone_number,
    }
    return this.http.get(url, {params: params, headers: headers})
      .map((response:Response) => response)
  }

  ConectBankV2(data){
    let url = this.actionUrl + 'auth/user/addAccount';
    const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
    return this.http.post(url, data, {headers})
      .map((response:Response) => response)
  }

  UpdatePhone_Number(data){
    let url = this.actionUrl + 'auth/user/verifyphone';
    const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
    const params = {
        otp_method: data.otp_method,
        confirm_phone_number: data.confirm_phone_number,
        change_phone: 'true',
    }
    return this.http.get(url, {params: params, headers: headers})
      .map((response:Response) => response)
  }

  VerifyPhone_NumberOTP(data){
    let url = this.actionUrl + 'auth/user/verifyphoneotp';
    const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
    const params = {
        otp_text: data.otp_text,
        confirm_phone_number: data.confirm_phone_number,
    }
    return this.http.get(url, {params: params, headers: headers})
      .map((response:Response) => response)
  }

  UpdatePhone_NumberOTP(data){
    let url = this.actionUrl + 'auth/user/verifyphoneotp';
    const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
    const params = {
        otp_text: data.otp_text,
        confirm_phone_number: data.confirm_phone_number,
        change_phone: 'true',
    }
    return this.http.get(url, {params: params, headers: headers})
      .map((response:Response) => response)
  }
  // validate code
  validateCode(data){
    const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
     return this.http.post(this.actionUrl +'auth/user/validatecode',data, {headers})
      	.map((response:Response) => response)
  }
  // Get otp
  getOtp(data){
	 return this.http.post(this.actionUrl +'auth/user/getotp',data)
		.map((response:Response) => response)
  }
  // Validate Otp
  validateOtp(data){
	 return this.http.post(this.actionUrl +'auth/user/verifyotp',data)
		.map((response:Response) => response)
  }
  logOutApi(token){
     return this.http.post(this.actionUrl +'auth/logout',token)
    .map((response:Response) => response)
  }
   // For Register 
	createRegister(data){
		/*if(data.user_token && data.id){
			return this.http.post(this.actionUrl +'auth/register/'+data.id,data)
			.map((response:Response) => response)
		}else{
			return this.http.post(this.actionUrl +'auth/register',data)
			.map((response:Response) => response)
		}*/

        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
        return this.http.post(this.actionUrl +'auth/register',data, { headers: headers })
			.map((response:Response) => response)
	}
    
    // verify email
    verifyEmail(data){
		let params = new URLSearchParams();
		let url = this.actionUrl + 'account/verify/'+data.token;
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
		return this.http.get(url, {params: {token: data.token}, headers: headers})
		.map((response:Response) => response)
	}

	// Get user data using token
	getUserDataApi(data){
		var user_token =  data.user_token;
		let params = new URLSearchParams();
		let url = this.actionUrl + 'get/user/info/'+user_token;;
		return this.http.get(url, {params: {token: data.token}})
		.map((response:Response) => response)
	}
	
	/* PROFILE */
	
	// Get Profile Details
	getProfileData(data){
        var id = data.id;
        let url = this.actionUrl + 'auth/get/profile/'+id;
        let params = new URLSearchParams();
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);

		return this.http.get(url,{params: {token: data.id}, headers})
        .map((response:Response) => response)
	}
    // Get Document List
    GetDocumentList(data){
        var id = data.merchantId;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.get(this.actionUrl +'get/merchant/document/'+id,  {headers})
        .map((response:Response) => response)
    }
    // Get Recurring invoice List
    GetRecurringInvoiceList(data){
        var id = data.merchantId;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.get(this.actionUrl +'get/recurrent/invoice/'+id,  {headers})
        .map((response:Response) => response)
    }
    // Get Document Type
    GetDocumentType(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.get(this.actionUrl +'get/merchant/document_type',  {headers})
        .map((response:Response) => response)
    }
    // Document upload
    LastMonthStatementUpload(data, Formdata){
        var id = data.merchantId;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'merchant/upload/document/'+id, Formdata, {headers})
        .map((response:Response) => response)
    }
    // Document update
    EditDocument_id(data, Formdata){
        var id = data.merchantId;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'merchant/update/document/'+id, Formdata, {headers})
        .map((response:Response) => response)
    }
    // Update Profile
    VendorImageUpload(data, Formdata){
        var id = data.id;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'update/merchant/image/'+id, Formdata, {headers})
        .map((response:Response) => response)
    }

	// Update Profile
    updateProfile(data, Formdata){
        var id = data.id;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'auth/update/profile/'+id,Formdata, {headers})
        .map((response:Response) => response)
    }
 	// Two factor enable and disable
    twoFactorEnableDisable(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        if(data.enableDisableStatus ===true){
            return this.http.post(this.actionUrl +'2fa/enable',data, {headers})
            .map((response:Response) => response)
        }
        if(data.enableDisableStatus ===false){
            return this.http.post(this.actionUrl +'2fa/disable',data, {headers})
            .map((response:Response) => response)
        }
    }
    // Save bank devails without signature
    saveBankDetailwithoutsign(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'auth/update/account/initial/'+data.id,data, {headers})
          .map((response:Response) => response)
    }
	// Save bank devails
    saveBankDetail(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'auth/update/account/'+data.id,data, {headers})
          .map((response:Response) => response)
    }
	// Update low cheque alert
    updateLowCheckAlert(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'auth/update/lowcheckalert/'+data.id,data, {headers})
        .map((response:Response) => response)
    }
	// invite merchant
	inviteMerchantUserAPI(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'auth/register/merchant/user/'+data.id,data, {headers})
          .map((response:Response) => response)
    }
	// get merchant users
	getMerchantUsersAPI(data){
        var id = data.id;
        let url = this.actionUrl + 'merchant/users/lists/'+id;
        let params = new URLSearchParams();
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
		return this.http.get(url,{headers})
        .map((response:Response) => response)
	}
	// get routing info
    getRoutingInfoApi(data){
        var id = data.id;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        let url = this.actionUrl + 'get/cheque/routing/info/'+id;
        let params = new URLSearchParams();
        return this.http.get(url,{params: {token: data.token,routing_number:data.routing_number},headers: headers})
        .map((response:Response) => response)
    }
	// Get merchant permissions
    getMerchantPermissionListApi(data){
      var _id =  data.id;
      let params = new URLSearchParams();
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      let url = this.actionUrl + 'get/permissions/role/'+data.role_id;
      return this.http.get(url, {params: {token: data.token,role_id:data.role_id}, headers: headers})
      .map((response:Response) => response)
    }

	// Get user permissions by id
    getUserPermissionByIdAPI(data){
        let params = new URLSearchParams();
        const headers = new HttpHeaders()
          .set('Authorization', `Bearer ${data.user_token}`);
        let url = this.actionUrl + 'auth/get/profile/'+data.id;
        return this.http.get(url, {params: {token: data.token}, headers: headers})
        .map((response:Response) => response)
      }
    
	// send invite or revoke access
    actionAccessApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
		var _id =  data._id;
	    return this.http.post(this.actionUrl +'update/user/'+_id,data, {headers})
          .map((response:Response) => response)
    }
	
	/* ACCOUNT */
	
	getAllUpcomingInvoicesData(data){
        let url = this.actionUrl + 'invoice/upcoming/'+data._id;
        let params = new URLSearchParams();
		return this.http.get(url,{params: {token: data.token}})
        .map((response:Response) => response)
	}
	UpdateCardDetailsApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
		var _id =  data._id;
		return this.http.post(this.actionUrl +'update/card/'+data._id,data, {headers})
        .map((response:Response) => response)
	}
	// Get User Details by Id
	getUserDetailByIdApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        let url = this.actionUrl + 'get/merchant/'+data._id;
        let params = new URLSearchParams();
		return this.http.get(url,{params: {token: data.token}, headers})
        .map((response:Response) => response)
	}
	
	/* PASSWORD */
	// Check user info using token
	checkUserInfo(data){
	  var user_token = data.user_token
      let url = this.actionUrl + 'get/user/info/'+user_token;
      return this.http.get(url)
      .map((response:Response) => response)
    }
	// set password
    setPasswordApi(data){
		var _id = data.id
        return this.http.post(this.actionUrl +'set/password/'+_id, data)
        .map((response:Response) => response)
    }
	// Recover password
	recoverPassword(data){
        return this.http.post(this.actionUrl +'password/forgot-password',data)
        .map((response:Response) => response)
    }

	// forgot password
    forgotPassword(data){
        return this.http.post(this.actionUrl +'password/reset/'+data.token,data)
        .map((response:Response) => response)
    }
	
	// get all sign up plan
	getAllSignupPlan(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.get(this.actionUrl +'plan/lists/signup',{params: {token: data.token}, headers: headers})
        .map((response:Response) => response)
	}
    
    // GetVerifySteps
	GetVerifySteps(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.get(this.actionUrl +'auth/user/verifysteps', {headers})
        .map((response:Response) => response)
    }
	// get stripe token
	getStripeToken(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'auth/signup/token/'+data._id,data, {headers})
        .map((response:Response) => response)
    }
	// subscribe to frre trial
	signupFreeTrialSubscribeApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
	    return this.http.post(this.actionUrl +'auth/signup/freetrial/'+data._id, data, {headers})
        .map((response:Response) => response)
	}

	// Free trial to active
	freeTrialToActivate(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'auth/user/active/'+data._id, data, {headers})
        .map((response:Response) => response)
    }

    // Renew subscription
    upgradeSubscription(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'auth/user/upgrade/'+data._id, data,  {headers})
        .map((response:Response) => response)
    }
	
	// Activity logs
	getActivityList(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        let url = this.actionUrl + 'activitylog/lists/'+data._id;
        // let params = new URLSearchParams();
		return this.http.get(url, {headers})
        .map((response:Response) => response)
	}
	
	// get merchant users
	getInvoiceUsersAPI(data){
        let url = this.actionUrl + 'invoice/listsbyuser';
        let params = new URLSearchParams();
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
		return this.http.post(this.actionUrl +'invoice/listsbyuser', data,  {headers})
        .map((response:Response) => response)
	}
    
    createEchexInvoice(data, formData){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'invoice/create', formData, {headers})
        .map((response:Response) => response)
    }

    userLogout(token){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${token}`);
        return this.http.post(this.actionUrl +'auth/logout', {}, {headers})
        .map((response:Response) => response)
    }

    // Activity logs
	getSingleInvoice(data){
        let url = this.actionUrl + 'invoice/view_invoice/'+data.id;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);

		return this.http.get(url, {headers})
        .map((response:Response) => response)
	}

    // resend email
	resendEmail(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);

		return this.http.post(this.actionUrl +'invoice/resend_email', data, {headers})
        .map((response:Response) => response)
	}

    checkUrlPermission(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'check/url/permission', data, {headers})
        .map((response:Response) => response)
    }

    // Update direct deposit
    updateDirectDeposit(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'auth/update/direct_deposit_settings/'+data.id, data,  {headers})
        .map((response:Response) => response)
    }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/user.service.ts